import { render, staticRenderFns } from "./materiel-manage.vue?vue&type=template&id=0829adab"
import script from "./materiel-manage.vue?vue&type=script&lang=js"
export * from "./materiel-manage.vue?vue&type=script&lang=js"
import style0 from "./materiel-manage.vue?vue&type=style&index=0&id=0829adab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports